import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BaseInput from "../BaseInput";

const formatFullName = (value) => {
    if (!value) return value;

    // Remove special characters but keep spaces
    const cleanValue = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");

    // Split into words and capitalize each word
    return cleanValue
        .split(" ")
        .map(word => {
            // Keep prepositions and conjunctions (2 or fewer characters) lowercase
            if (word.length <= 2) return word.toLowerCase();
            // Capitalize first letter, lowercase the rest
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
};

const FullNameInput = ({ value, onInput, label, placeholder, variant = 'light', ...props }) => {
    const { t } = useTranslation('fragments');
    const [localValue, setLocalValue] = useState(value || "");

    useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleChange = (newValue) => {
        const formattedValue = formatFullName(newValue);
        setLocalValue(formattedValue);
        onInput(formattedValue);
    };

    const handleBlur = () => {
        const trimmedValue = localValue.trim();
        setLocalValue(trimmedValue);
        onInput(trimmedValue);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            onBlur={handleBlur}
            label={label ?? t('input.fullName.label')}
            placeholder={placeholder ?? t('input.fullName.placeholder')}
            variant={variant}
        />
    );
};

export default FullNameInput;
